import React from 'react';

export default () => (
	<svg 
		width="18" 
		height="17" 
		viewBox="0 0 18 17" 
		fill="none" 
		xmlns="http://www.w3.org/2000/svg"
	>
		<path 
			d="M9.13166 1L1.63165 8.5L9.13166 16" 
			stroke="#191919" 
			strokeWidth="2"
		/>
		<path 
			d="M2.38147 8.5H17.3815" 
			stroke="#191919" 
			strokeWidth="2"
		/>
	</svg>
)